import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCards({ summaryData }) {
    const currentLeadData = [
        {
            amount: "₹" + (summaryData?.totalBalance || "0"),
            label: "Total Balance",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'T',
        },
        {
            amount: "₹" + (summaryData?.totalCollection || "0"),
            label: "Total Collection",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'N',
        },
        {
            amount: "₹" + (summaryData?.totalExpense || "0"),
            label: "Total Expense",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'FU',
        },
        {
            amount: "₹" + (summaryData?.totalGivenToClient || "0"),
            label: "Given to Owner",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'VS',
        },
        {
            amount: "₹" + (summaryData?.totalReimbursed || "0"),
            label: "Total Reimbursed",
            color: "text-black",
            icon: <FaUser className="text-black" />,
            filter: 'C',
        },

    ];

    return (
        <Wrapper>

            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {currentLeadData.map((item, index) => (
                    <Card index={index} key={index}
                    >
                        <ValueRow>
                            <Value color={item.color}>{item.amount}</Value>

                        </ValueRow>
                        <Label>
                            {item.label}
                        </Label>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;

const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;

